function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  stroke: "white",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  fillOpacity: 1
}, React.createElement("g", {
  transform: "translate(-653.000000, -769.000000)",
  fill: "none"
}, React.createElement("path", {
  d: "M723.098733,820.810815 C759.383272,820.810815 762.229118,820.810815 774.323965,772 L766.497888,772 C763.296311,781.541964 760.450465,783.009958 753.335849,783.009958 C736.972233,783.376957 720.608617,783.743956 701.399155,783.743956 C680.055308,783.743956 676.853731,786.679944 676.14227,802.827883 L671.51777,890.540551 C679.343847,886.870565 687.881386,885.035572 696.418924,885.035572 C730.92481,885.035572 736.260772,916.230454 736.260772,945.223344 C736.260772,976.051228 731.280541,1004.67712 701.754886,1004.67712 C690.371501,1004.67712 680.411039,999.906137 680.411039,993.667161 C680.411039,985.226193 699.26477,988.162182 699.26477,966.509264 C699.26477,958.068296 692.861616,947.058337 679.699578,947.058337 C665.826077,947.058337 658,956.9673 658,970.913247 C658,998.438143 682.189693,1013.48509 706.735117,1013.48509 C757.604618,1013.48509 782.150042,979.354215 782.150042,942.287355 C782.150042,903.752501 751.557195,874.759611 714.205463,874.759611 C702.466347,874.759611 691.438693,876.227605 680.055308,880.26459 L683.968347,820.810815 L723.098733,820.810815 Z"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    "data-v-59251244": "",
    width: "134px",
    height: "251px",
    viewBox: "0 0 134 251",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "number-5 number"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/5.6db60aa6.svg";
export { SvgComponent as ReactComponent };